import React from 'react'
import { AppFilterDropdown } from 'components/AppDropdown/AppFilterDropdown'
import { AppFilterMultiDropdown } from 'components/AppDropdown/AppFilterMultiDropdown'

const SOURCE_FILTER_OPTIONS = [
  { value: 'Imported', name: 'Импортирован' },
  { value: 'Dimension', name: 'Замер' },
]

const STATUS_FILTER_OPTIONS = [
  { value: 'Compliant', name: 'Соответствует' },
  { value: 'Non_compliant', name: 'Не соответствует' },
  { value: 'Not_determined', name: 'Без статуса' },
]

interface IAiDatasetStatsRowProps {
  total: number
  matchCount: number
  noMatchCount: number
  notLabeledCount: number
  readyForTraining: boolean
  mismatchOptions: { id: number; name: string }[]
}

export const AiDatasetStatsRow: React.FC<IAiDatasetStatsRowProps> = ({
  total,
  matchCount,
  noMatchCount,
  notLabeledCount,
  readyForTraining,
  mismatchOptions,
}) => {
  const items = [
    { label: 'Всего фотографий', value: total, className: 'total' },
    { label: 'Соответствует', value: matchCount, className: 'match' },
    { label: 'Не соответствует', value: noMatchCount, className: 'no-match' },
    { label: 'Не размечено', value: notLabeledCount, className: 'not-labeled' },
  ]

  return (
    <div className="ai-dataset-stats-panel">
      <div className="ai-dataset-stats-row">
        {items.map((item) => (
          <div className={`ai-dataset-stats-tile ${item.className}`} key={item.label}>
            <div className="ai-dataset-stats-tile-value">{item.value}</div>
            <div className="ai-dataset-stats-tile-label">{item.label}</div>
          </div>
        ))}
        <div
          className={`ai-dataset-stats-tile ${
            readyForTraining ? 'ready' : 'not-ready'
          }`}
        >
          <div className="ai-dataset-stats-tile-value">
            {readyForTraining ? 'Да' : 'Нет'}
          </div>
          <div className="ai-dataset-stats-tile-label">Готово к обучению</div>
        </div>
      </div>
      <div className="filter-block no-wrap">
        <AppFilterDropdown
          searchParam="uploaded_from"
          data={SOURCE_FILTER_OPTIONS}
          valuePropName="value"
          propToShowInList="name"
          label="Источник"
          placeholder="Все источники"
          fullWidth
        />
        <AppFilterDropdown
          searchParam="compliance_with_standards"
          data={STATUS_FILTER_OPTIONS}
          valuePropName="value"
          propToShowInList="name"
          label="Статус"
          placeholder="Все статусы"
          fullWidth
        />
        <AppFilterMultiDropdown
          searchParam="non_compliant_type_ids"
          data={mismatchOptions}
          valuePropName="id"
          propToShowInList="name"
          label="Тип несоответствия"
          placeholder="Все типы"
          fullWidth
        />
      </div>
    </div>
  )
}
